var React = require('react');

function CheckCircled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C14.3582 4 16.478 5.02032 17.9422 6.64358L11 13.5858L8.20711 10.7929C7.81658 10.4024 7.18342 10.4024 6.79289 10.7929C6.40237 11.1834 6.40237 11.8166 6.79289 12.2071L9.58579 15C10.3668 15.7811 11.6332 15.781 12.4142 15L19.1015 8.31276C19.6755 9.41616 20 10.6702 20 12Z","fill":"black"}));
}

CheckCircled.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckCircled;

CheckCircled.default = CheckCircled;
